/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 public/Nethan_Avatar.glb
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('/Nethan_Avatar.glb')
  return (
    <group {...props} dispose={null}>
      <group position={[-0.18, 1.32, 2.24]} rotation={[0, 0, 0.08]} scale={[1.09, 0.85, 1.09]}>
        <mesh geometry={nodes.NurbsPath.geometry} material={materials['Material.001']} position={[0, -0.23, 0]} scale={[0.24, 0.95, 0.2]} />
      </group>
      <mesh geometry={nodes.Cylinder.geometry} material={materials['GT Shift']} position={[-0.07, -0.07, -0.15]} rotation={[0, 0, 0.09]} scale={[0.76, 0.86, 0.68]} />
      <mesh geometry={nodes.Cylinder001.geometry} material={materials['Skin Color.001']} position={[0.38, -1.31, -0.15]} rotation={[0, 0, 0.11]} scale={[0.28, 0.57, 0.28]} />
      <mesh geometry={nodes.Cylinder002.geometry} material={materials['Skin Color.001']} position={[-0.33, -1.31, -0.15]} rotation={[0.15, 0, -0.03]} scale={[0.28, 0.57, 0.28]} />
      <mesh geometry={nodes.Sphere.geometry} material={materials['Skin Color.001']} position={[-0.2, 1.59, -0.15]} rotation={[0, 0, 0.08]} scale={1.06} />
      <mesh geometry={nodes.Cylinder004.geometry} material={materials['Skin Color.001']} position={[-1.1, 0.03, -0.15]} rotation={[0, 0, -0.83]} scale={[0.3, 0.68, 0.3]} />
      <mesh geometry={nodes.Cylinder003.geometry} material={materials['Skin Color.001']} position={[1.08, 0.64, -0.15]} rotation={[0, 0, 2.19]} scale={[0.3, 0.68, 0.3]} />
      <mesh geometry={nodes.BezierCurve.geometry} material={materials.Material} position={[-0.29, 2.7, -0.15]} rotation={[0.04, -0.43, -1.48]} scale={[0.08, 0.37, 0.37]} />
      <mesh geometry={nodes['Georgia-Tech-Logo-PNG-Clipart'].geometry} material={materials['Georgia-Tech-Logo-PNG-Clipart']} position={[-0.07, -0.07, 0.53]} rotation={[Math.PI / 2, 0.08, 0]} scale={0.58} />
      <mesh geometry={nodes.Cube.geometry} material={materials['Material.002']} position={[-0.23, 1.99, 0.95]} rotation={[0, 0, 0.08]} scale={[0.97, 0.34, 0.03]} />
    </group>
  )
}

useGLTF.preload('/Nethan_Avatar.glb')
